export const FAKE_PUSH_THROTTLE_IN_MS = 3000;
